import React from "react";
import { cn } from "@/lib/utils";

export interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  variant?: "default" | "sm" | "lg";
  background?: "white" | "gray" | "red" | "gradient-red" | "gradient-light" | "transparent";
  children: React.ReactNode;
}

const Section = React.forwardRef<HTMLElement, SectionProps>(
  ({ className, variant = "default", background = "transparent", children, ...props }, ref) => {
    const variantClasses = {
      default: "section-default",
      sm: "section-compact",
      lg: "section-large",
    };

    const backgroundClasses = {
      transparent: "transparent",
      white: "section-bg-white",
      gray: "section-bg-gray",
      red: "bg-red-50",
      "gradient-red": "cta-section",
      "gradient-light": "py-[60px] lg:py-20 bg-gradient-to-r from-red-50 to-orange-50",
    };

    return (
      <section
        className={cn(variantClasses[variant], backgroundClasses[background], className)}
        ref={ref}
        {...props}
      >
        <div className="container mx-auto px-8 xl:px-0">{children}</div>
      </section>
    );
  }
);

Section.displayName = "Section";

export { Section };
